import { render, staticRenderFns } from "./RealStateList.vue?vue&type=template&id=33885e9c&"
import script from "./RealStateList.vue?vue&type=script&lang=js&"
export * from "./RealStateList.vue?vue&type=script&lang=js&"
import style0 from "./RealStateList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports